import React from "react";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {BaseLayout} from "../Layout/BaseLayout";
import {useServerRoutes} from "../Menu/useServerRoutes";
import {Loading} from "../Loading/Loading";

export const MyRoutes = () => {

    const {userRoutes} = useServerRoutes();

    if (userRoutes && userRoutes.length === 0) {
        return <Loading isLoading={true}/>
    }

    const router = createBrowserRouter([{
        path: "/", element: <BaseLayout/>, children: userRoutes
    }])

    return <RouterProvider router={router}/>
};
